import { createStore } from 'vuex';

const store = createStore({
  state: {
    isAuthenticated: false
  },
  mutations: {
    setAuthenticated(state, status) {
      state.isAuthenticated = status;
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated
  }
});

export default store;
